module.exports = __webpack_public_path__ + "img/impostor-backstab.e6802bfb.webp";